__turbopack_context__.v({
  "closeButton": "ImageBlock-module__JPG7aa__closeButton",
  "fullscreenImage": "ImageBlock-module__JPG7aa__fullscreenImage",
  "image": "ImageBlock-module__JPG7aa__image",
  "modalBody": "ImageBlock-module__JPG7aa__modalBody",
  "paper": "ImageBlock-module__JPG7aa__paper",
});
